{
  "audit": {
    "lookup": {
      "label": "البحث عن سجل",
      "placeholder": "الرقم المرجعي، مثل PR-000072",
      "selected": "السجل المحدد",
      "kind": {
        "request": "طلب شراء",
        "purchase_order": "أمر شراء",
        "rfq": "طلب عروض",
        "supplier": "مورد",
        "catalogue_item": "صنف في الكتالوج"
      }
    }
  }
}
